import { combineReducers } from 'redux';

import isOpen from './isOpen';

/**
 * @typedef {{
 *  isOpen : import('./isOpen').IsOpenState;
 * }} SendState
 */
export default combineReducers({
  isOpen,
});
